// extracted by mini-css-extract-plugin
module.exports = {"only-view":"styles_only-view__3JpT9"};